import { render, staticRenderFns } from "./ListadoAcuerdosClientesBaseTabla.vue?vue&type=template&id=233348cf"
import script from "./ListadoAcuerdosClientesBaseTabla.vue?vue&type=script&lang=js"
export * from "./ListadoAcuerdosClientesBaseTabla.vue?vue&type=script&lang=js"
import style0 from "./ListadoAcuerdosClientesBaseTabla.vue?vue&type=style&index=0&id=233348cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports